import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { ImageSlider } from './ImageSlider';
import { ZapIcon, CameraIcon, ShieldCheckIcon } from 'lucide-react';
import { useCart } from '../contexts/CartContext';
export function Hero() {
  const {
    addToCart
  } = useCart();
  const productImages = ['https://cdn.magicpatterns.com/uploads/ddWEZuz6pnzGe64ipqMMCE/ChatGPT_Image_Feb_19,_2026,_03_27_07_PM.png', 'https://cdn.magicpatterns.com/uploads/4PjnFwjfg2ZHLfCNVEvgAM/7.webp', 'https://cdn.magicpatterns.com/uploads/f9TU3SCSFpCmHaLZqHpRYt/ChatGPT_Image_Feb_18,_2026,_08_59_35_PM.png'];
  const keyBenefits = [{
    icon: ZapIcon,
    text: 'Clinically optimized laser dosage'
  }, {
    icon: CameraIcon,
    text: 'Tracks progression with photo-based check-ins'
  }, {
    icon: ShieldCheckIcon,
    text: "180-Day 'See Change or Don't Pay' Guarantee"
  }];
  return <section className="w-full bg-white pt-12 pb-16 px-4" data-id="element-106">
      <div className="max-w-7xl mx-auto" data-id="element-107">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-108">
          {/* Left Column - Copy */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="order-2 lg:order-1" data-id="element-109">
            {/* Pre-Headline (Callout / Qualifier) */}
            <div className="mb-6" data-id="element-110">
              <span className="text-brand-red font-bold text-lg tracking-wide" data-id="element-111">
                For men who refuse to shave it – but won't gamble their hormones
                to keep it.
              </span>
            </div>

            {/* Main Headline */}
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight" data-id="element-112">
              Your Hair Isn't Dead. It's Energy-Starved.
            </h1>

            {/* Image Slider - Mobile Only (shows above subheadline on mobile) */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="flex items-center justify-center mb-8 lg:hidden" data-id="element-113">
              <ImageSlider images={productImages} alt="CrownControl device" data-id="element-114" />
            </motion.div>

            {/* Subheadline */}
            <p className="text-xl text-gray-700 mb-8 leading-relaxed" data-id="element-115">
              A non‑hormonal, FDA‑cleared protocol that restores follicle
              activity in 10 minutes a day – without touching your libido.
            </p>

            {/* Short Hero Body */}
            <div className="space-y-4 text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-116">
              <p data-id="element-117">
                A gust of wind, a bad overhead photo, or brutal office lighting
                shouldn't be enough to ruin your day.
              </p>

              <p data-id="element-118">
                If you're here, you already know finasteride, minoxidil, and
                transplants exist – you're just not willing to trade your
                hormones, your bank account, or your identity to keep your hair.
              </p>

              <p className="font-semibold text-gray-900" data-id="element-119">
                CrownControl™ gives you a fourth option: a medical‑grade light
                protocol that targets follicle energy, not your hormones.
              </p>
            </div>

            {/* Key Benefits - Icon Bullets */}
            <div className="space-y-4 mb-8" data-id="element-120">
              {keyBenefits.map((benefit, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -10
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 0.4,
              delay: 0.2 + index * 0.1
            }} className="flex items-center gap-3" data-id="element-121">
                  <div className="w-10 h-10 bg-brand-red/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-122">
                    <benefit.icon className="w-5 h-5 text-brand-red" aria-hidden="true" data-id="element-123" />
                  </div>
                  <span className="text-gray-700 font-medium" data-id="element-124">
                    {benefit.text}
                  </span>
                </motion.div>)}
            </div>

            {/* Single Primary CTA */}
            <div className="mb-6" data-id="element-125">
              <CTAButton variant="primary" onClick={addToCart} ariaLabel="Start the 180-Day CrownControl Protocol" data-id="element-126">
                Start the 180-Day CrownControl Protocol
              </CTAButton>
            </div>

            {/* Sub-text */}
            <p className="text-sm text-gray-600" data-id="element-127">
              One-time payment of $497 · Free shipping · 180-Day Guarantee
            </p>
          </motion.div>

          {/* Right Column - Image Slider (Desktop Only) */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="hidden lg:flex items-center justify-center order-1 lg:order-2" data-id="element-128">
            <ImageSlider images={productImages} alt="CrownControl device" data-id="element-129" />
          </motion.div>
        </div>
      </div>
    </section>;
}